function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D9AAE"
    },
    d: "M423.724,388.415h-17.655v70.621h17.655v-26.483h11.3l6.798,20.48 c1.215,3.596,4.591,6.012,8.386,6.002h17.655v-17.655h-11.3l-5.914-17.655l5.914-17.655h11.3v-17.655h-17.655 c-3.956-0.206-7.566,2.248-8.828,6.002l-6.355,20.48h-11.3L423.724,388.415L423.724,388.415z M388.414,397.242 c0-4.876-3.952-8.828-8.827-8.828h-35.31c-4.876,0-8.827,3.952-8.827,8.828v52.965c0,4.876,3.952,8.828,8.827,8.828h35.31 c4.876,0,8.827-3.952,8.827-8.828V397.242z M494.345,467.862H308.965v-88.276h185.379V467.862z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 423.719,
    cy: 88.271,
    r: 17.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M435.023,432.552h-11.3v26.483h-17.655v-70.621h17.655v26.483h11.3l6.798-20.48 c1.215-3.596,4.591-6.012,8.386-6.002h17.655v17.655h-11.3l-5.914,17.655l5.914,17.655h11.3v17.655h-17.655 c-3.956,0.206-7.566-2.248-8.828-6.002L435.023,432.552z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 353.103,
    y: 406.065,
    style: {
      fill: "#2FB4C2"
    },
    width: 17.655,
    height: 35.31
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M388.414,397.242v52.965c0,4.876-3.952,8.828-8.827,8.828h-35.31c-4.876,0-8.827-3.952-8.827-8.828 v-52.965c0-4.876,3.952-8.828,8.827-8.828h35.31C384.462,388.415,388.414,392.366,388.414,397.242z M370.759,406.07h-17.655v35.31 h17.655V406.07z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 335.449,
    cy: 88.271,
    r: 17.655
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M300.137,361.931h203.035c4.876,0,8.828,3.952,8.828,8.828V476.69c0,4.876-3.952,8.827-8.828,8.827 H300.137c-4.876,0-8.827-3.952-8.827-8.827V370.759C291.31,365.884,295.263,361.931,300.137,361.931z M308.965,467.862h185.379 v-88.276H308.965V467.862z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 247.168,
    cy: 88.271,
    r: 17.655
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 247.168,
    cy: 264.822,
    r: 17.655
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 158.897,
    cy: 88.271,
    r: 17.655
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 158.897,
    cy: 264.822,
    r: 17.655
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 70.616,
    cy: 88.271,
    r: 17.655
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42210B"
    },
    cx: 70.616,
    cy: 264.822,
    r: 17.655
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M158.896,70.621c-9.75,0-17.655,7.905-17.655,17.655s7.905,17.655,17.655,17.655 s17.655-7.905,17.655-17.655C176.551,78.526,168.647,70.621,158.896,70.621z M247.172,70.621c-9.75,0-17.655,7.905-17.655,17.655 s7.905,17.655,17.655,17.655c9.75,0,17.655-7.905,17.655-17.655C264.827,78.526,256.923,70.621,247.172,70.621z M423.724,70.621 c-9.75,0-17.655,7.905-17.655,17.655s7.905,17.655,17.655,17.655c9.75,0,17.655-7.905,17.655-17.655S433.475,70.621,423.724,70.621 z M70.621,70.621c-9.75,0-17.655,7.905-17.655,17.655s7.905,17.655,17.655,17.655s17.655-7.905,17.655-17.655 S80.371,70.621,70.621,70.621z M30.367,44.139h451.266c6.971-0.049,12.663,5.563,12.712,12.535c0,0.059,0,0.118,0,0.177v62.853 c0.049,6.971-5.563,12.663-12.535,12.712c-0.059,0-0.118,0-0.177,0H30.367c-6.971,0.049-12.663-5.563-12.712-12.535 c0-0.059,0-0.118,0-0.177V56.85c-0.049-6.971,5.563-12.663,12.535-12.712C30.249,44.138,30.307,44.138,30.367,44.139z  M335.449,70.621c-9.75,0-17.655,7.905-17.655,17.655s7.905,17.655,17.655,17.655c9.75,0,17.655-7.905,17.655-17.655 S345.199,70.621,335.449,70.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M247.172,220.69H17.655v88.276h476.69V220.69H247.172z M70.621,282.483 c-9.75,0-17.655-7.905-17.655-17.655c0-9.75,7.905-17.655,17.655-17.655s17.655,7.905,17.655,17.655 C88.276,274.579,80.371,282.483,70.621,282.483z M158.896,282.483c-9.75,0-17.655-7.905-17.655-17.655 c0-9.75,7.905-17.655,17.655-17.655s17.655,7.905,17.655,17.655C176.551,274.579,168.647,282.483,158.896,282.483z  M247.172,282.483c-9.75,0-17.655-7.905-17.655-17.655c0-9.75,7.905-17.655,17.655-17.655c9.75,0,17.655,7.905,17.655,17.655 C264.827,274.579,256.923,282.483,247.172,282.483z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M494.345,132.415V44.139H17.655v88.276C17.655,132.415,494.345,132.415,494.345,132.415z  M8.828,26.484h494.345c4.876,0,8.828,3.952,8.828,8.828v105.931c0,4.876-3.952,8.828-8.828,8.828H8.828 c-4.876,0-8.828-3.952-8.828-8.828V35.311C0,30.435,3.952,26.484,8.828,26.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M247.172,220.69H17.655v88.276h476.69V220.69H247.172z M0,317.793V211.862 c0-4.876,3.952-8.828,8.828-8.828h494.345c4.876,0,8.828,3.952,8.828,8.828v105.931c0,4.876-3.952,8.828-8.828,8.828H8.828 C3.952,326.621,0,322.669,0,317.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0CBB5"
    },
    d: "M17.655,44.139v88.276h476.69V44.139H17.655z M485.517,123.586H26.483V52.966h459.035v70.621 H485.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0CBB5"
    },
    d: "M247.172,220.69H17.655v88.276h476.69V220.69H247.172z M485.517,300.138H26.483v-70.621h459.035 v70.621H485.517z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.411,
    y: 397.244,
    style: {
      fill: "#2FB4C2"
    },
    width: 17.655,
    height: 52.965
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2FB4C2"
    },
    points: "423.724,397.242 423.724,414.897 435.023,414.897 440.849,397.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2FB4C2"
    },
    points: "423.724,450.207 440.849,450.207 435.023,432.552 423.724,432.552  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FB4C2"
    },
    d: "M467.862,397.772v8.298h-11.3l-6.355,17.655l5.914,17.655h11.741v8.298 c5.219-1.525,8.812-6.303,8.828-11.741v-28.337C476.713,404.131,473.112,399.306,467.862,397.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FB4C2"
    },
    d: "M326.621,409.601v28.249c0.016,5.437,3.609,10.215,8.828,11.741v-51.818 C330.198,399.306,326.598,404.131,326.621,409.601z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.f06c48b62f17adef1c6d32b1972586f3.svg";
export { ForwardRef as ReactComponent };